import React from 'react'
import { AgTechTabbedPageTabProps, AgTechTabPageTemplate, AgTechTabbedPageTab } from '../AgTechTabPage';
import AgTechHeaderDetail, { AgTechHeaderDetailProps } from '../../../Headers/AgTechHeaderDetail';

const AgTechViewDialogTabPage = (props: {
    tabs: AgTechTabbedPageTabProps[],
    header: AgTechHeaderDetailProps
}) => {
    return (
        <AgTechTabPageTemplate
            tabs={props.tabs}
            body={{
                classes: 'p-body'
            }}
            panel={() => (
                <div className="row-based border-b bg-white px-4 pt-3 pb-0 container" style={{ height: 120 }}>
                    <AgTechHeaderDetail
                        {...props.header}
                        settings={{
                            header: {
                                classes: '!text-more'
                            },
                            ...props.header.settings
                        }}
                    />
                    <div className='flexed container' />
                    <div className="vertically-centered container">       
                        { props.tabs.map(tab => (
                            <AgTechTabbedPageTab
                                key={props.header.header + tab.text}
                                {...tab}
                                classes={{
                                    tab: 'min-w-[80px] centered font-semibold text-sm border-b border-b-[2px] border-b-transparent mr-4 px-2 mt-[1px] pb-[7px]',
                                    inactive: 'text-detail',
                                    active: '!border-highlight text-primary'
                                }}
                            />
                        )) }
                    </div>
                </div>
            )}
        />
    )
};

export default AgTechViewDialogTabPage